const library = {
  ა: "a",
  ბ: "b",
  გ: "g",
  დ: "d",
  ე: "e",
  ვ: "v",
  ზ: "z",
  თ: "t",
  ი: "i",
  კ: "k",
  ლ: "l",
  მ: "m",
  ნ: "n",
  ო: "o",
  პ: "p",
  ჟ: "zh",
  რ: "r",
  ს: "s",
  ტ: "t",
  უ: "u",
  ფ: "f",
  ქ: "q",
  ღ: "gh",
  ყ: "y",
  შ: "sh",
  ჩ: "ch",
  ც: "c",
  ძ: "dz",
  წ: "ts",
  ჭ: "tch",
  ხ: "kh",
  ჯ: "j",
  ჰ: "h",
};

export const toEng = (string, options) => {
  if (string) {
    let array = string.split("");
    array.forEach((letter, index) => array[index] = library[letter] || letter);
    
    array = array.join("").split("");
    if (options?.capFirstLetters) {
      const words = [];
      let lastIndex = 0;
      array.concat([" "]).forEach((item, index) => {
        if (item === " ") {
          if (lastIndex === 0) {
            words.push(array.slice(lastIndex, index));
          } else {
            words.push(array.slice(lastIndex + 1, index));
          }
          lastIndex = index;
        }
      });
      const wordArray = [];
      words.forEach((item) => {
        item[0] = item[0]?.toUpperCase();
        wordArray.push(item.join(""));
      });
      switch (wordArray[0]) {
        case "Shps":
          wordArray[0] = "Ltd";
          break;
        default:
          break;
      }
      array = wordArray.join(" ");
    } else {
      array = array.join("");
    }
    return array;
  }
};
